import type { NormalizedApiError } from "~/store/middleware/normalizeApiError";

export interface TenantInactiveClassification {
	expiredTrial: boolean;
}

// wsapi emits code TENANT_INACTIVE with a boolean expiredTrial extension
const TENANT_INACTIVE_CODE = "TENANT_INACTIVE";

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null && !Array.isArray(value);

const classifyTenantInactiveError = (normalized: NormalizedApiError): TenantInactiveClassification | null => {
	const errors = normalized.graphqlErrors;
	if (!errors) return null;

	for (const error of errors) {
		const extensions = error.extensions;
		if (!isRecord(extensions)) continue;
		if (extensions.code !== TENANT_INACTIVE_CODE) continue;
		return { expiredTrial: extensions.expiredTrial === true };
	}

	return null;
};

export default classifyTenantInactiveError;
